import ko from 'knockout';

export default class ViewModel {
  constructor({
    scenario,
    activityLogger,
  } = {}) {
    this.selectedCampaigns = ko.observable();
    this.selectedAdgroups = ko.observable();

    this.copySetting = ko.observable(false);
    this.hide = ko.observable(false);

    this.copySetting.subscribe((value) => {
      if (activityLogger) {
        activityLogger.signal(`copy campaign settings value change: ${value}`, scenario);
      }
    });
  }
}
